export enum FilterStatusEnum {
    INITIAL = 'INITIAL',
    CHANGED = 'CHANGED',
    TEMPLATE = 'TEMPLATE',
    'CHANGED_TEMPLATE' = 'CHANGED_TEMPLATE',
}
